import firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyCQWqXb0L-LBhs6WdLx51VQ6vVT0hIyjSk",
  authDomain: "hotstar-clone-d1f1e.firebaseapp.com",
  projectId: "hotstar-clone-d1f1e",
  storageBucket: "hotstar-clone-d1f1e.appspot.com",
  messagingSenderId: "988595105786",
  appId: "1:988595105786:web:d52e37c2acc19208807e43",
  measurementId: "G-1Z9X13J4JB"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { auth, provider, storage };
export default db;
